import { useIsJobTimedOut } from '@hooks/useIsJobTimedOut';
import { useUpdateSalesBOMJob } from '@hooks/useUpdateSalesBOMJob';
import { type SalesBomJob } from '@providers/job/types';
import { GETSBOMJobResponse } from '@services/productInventory';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useSalesBOMTimeoutHandler = (
  salesBOMJobData: GETSBOMJobResponse /* TECH DEBT this is a duplicate type */ | SalesBomJob | undefined,
  accountId: string
) => {
  const { t } = useTranslation('common');
  const { mutate: updateSalesBOMJob } = useUpdateSalesBOMJob();

  const hasJobTimedOut = useIsJobTimedOut(salesBOMJobData);
  const isInProgress = salesBOMJobData?.status.startsWith('IN_PROGRESS');

  useEffect(() => {
    if (hasJobTimedOut && isInProgress) {
      updateSalesBOMJob({
        runID: salesBOMJobData?.runID!,
        accountId,
        status: 'FAILED',
        errors: [{ source: 'vtaas-ui', message: `${t('salesBOMTimeoutError')}` }],
      });
    }
  }, [accountId, hasJobTimedOut, isInProgress, salesBOMJobData?.runID, t, updateSalesBOMJob]);
};
